import { getProductCategories } from "@dillon/Services/CommonServices";
import { setGA4Event } from "@dillon/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ExecuteOnSuccessCallback,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/PlaceOrder";

import { chain as SetPaymentDetailsStateChain, SetPaymentDetailsState } from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SetPaymentDetailsState";

// Verndale Customization ticket: DSSM-486
addToChainBefore(chain, ExecuteOnSuccessCallback, async props => {
    const products = props.apiParameter.cart.cartLines;
    const paymentInfo = props.apiParameter.cart.paymentMethod?.description;
    
    const result = await getProductCategories({
        productIds: [...products!.map(cl => cl.productId!)],
        type: "product",
    });

    if (result.successful) {
        const productCategories = result.result;
        setGA4Event([...products!], "add_payment_info", {productCategories, paymentType: paymentInfo});
    }
});

addToChainAfter(SetPaymentDetailsStateChain, SetPaymentDetailsState, async props => {
    if ( props.parameter.paymentDetailsState === "complete") {
        const cartState = props.getState().data.carts;
        const cartId = cartState.currentId || "current";
        const cartLines = cartState.byId[cartId]?.cartLines;
        const paymentMethod = cartState.byId[cartId]?.paymentMethod;
        
        const result = await getProductCategories({
            productIds: [...cartLines!.map(cl => cl.productId!)],
            type: "product",
        });
    
        if (result.successful) {
            const productCategories = result.result;
            setGA4Event([...cartLines!], "add_payment_info", {productCategories, paymentType: paymentMethod});
        }
    }
});
// End of Verndale Customization ticket: DSSM-474